import { xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class RecurrenteAPI {
	createCheckout(product_id: PGSchema.products["id"]) {
		return xhttp<{ checkout: { id: string; checkout_url: string } }>(`/recurrente/checkout`, "POST", { product_id });
	}

	cancelSubscription(id: number) {
		return xhttp<{ subscription: PGSchema.subscriptions }>(`/recurrente/subscriptions/${id}`, "DELETE");
	}
}
